export function SignInNeuralBackdrop() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(148deg,#ffffff_0%,#ffe8d2_24%,#ffb56a_58%,#ff7a18_82%,#e85d00_100%)]" />
      <div className="absolute inset-[-20%] animate-signin-wash bg-[radial-gradient(46rem_36rem_at_16%_10%,rgba(255,255,255,0.9),transparent_60%)] motion-reduce:animate-none" />
      <div className="absolute inset-[-20%] animate-signin-wash bg-[radial-gradient(50rem_40rem_at_88%_90%,rgba(232,93,0,0.75),transparent_62%)] motion-reduce:animate-none [animation-delay:-9s]" />
      <div className="absolute inset-[-14%] animate-signin-wash bg-[radial-gradient(30rem_26rem_at_58%_34%,rgba(255,210,150,0.5),transparent_72%)] motion-reduce:animate-none [animation-delay:-4s]" />

      <svg
        aria-hidden
        className="absolute inset-0 h-full w-full motion-reduce:opacity-75"
        viewBox="0 0 1100 720"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <filter
            id="signin-pathway-soft"
            x="-35%"
            y="-35%"
            width="170%"
            height="170%"
            colorInterpolationFilters="sRGB"
          >
            <feGaussianBlur stdDeviation="10" result="blur" />
            <feTurbulence type="fractalNoise" baseFrequency="0.018" numOctaves="3" result="noise" />
            <feDisplacementMap
              in="blur"
              in2="noise"
              scale="36"
              xChannelSelector="R"
              yChannelSelector="G"
              result="warped"
            />
            <feComponentTransfer in="warped" result="faint">
              <feFuncA type="linear" slope="0.7" />
            </feComponentTransfer>
          </filter>
          <filter id="signin-grain" x="0%" y="0%" width="100%" height="100%">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.9"
              numOctaves="3"
              stitchTiles="stitch"
            />
            <feColorMatrix type="saturate" values="0" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.7" />
            </feComponentTransfer>
          </filter>
          <radialGradient id="signin-faint-glow-a" cx="35%" cy="30%" r="55%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.7" />
            <stop offset="55%" stopColor="#ffd7a8" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#ffd7a8" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="signin-faint-glow-b" cx="70%" cy="68%" r="50%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.4" />
            <stop offset="60%" stopColor="#ff9a3c" stopOpacity="0.14" />
            <stop offset="100%" stopColor="#ff9a3c" stopOpacity="0" />
          </radialGradient>
        </defs>

        <g
          className="animate-signin-synapse-drift motion-reduce:animate-none"
          filter="url(#signin-pathway-soft)"
          opacity="0.9"
        >
          <path
            d="M-80 210 C 140 40, 260 390, 470 180 S 780 20, 980 250 S 1180 430, 1280 210"
            fill="none"
            stroke="#fffaf5"
            strokeWidth="28"
            strokeLinecap="round"
          />
          <path
            d="M-40 470 C 180 300, 320 620, 560 410 S 860 220, 1040 500 S 1220 640, 1320 420"
            fill="none"
            stroke="#ffe8cf"
            strokeWidth="24"
            strokeLinecap="round"
          />
          <path
            d="M 120 -60 C 220 180, 90 340, 340 420 S 620 560, 760 300 S 980 80, 1180 280"
            fill="none"
            stroke="#ffffff"
            strokeWidth="22"
            strokeLinecap="round"
          />
          <path
            d="M 280 780 C 360 520, 520 680, 680 460 S 900 240, 1040 520"
            fill="none"
            stroke="#ffd9b0"
            strokeWidth="26"
            strokeLinecap="round"
          />
          <path
            d="M 900 -40 C 760 160, 980 260, 820 420 S 640 620, 860 700"
            fill="none"
            stroke="#fff3e4"
            strokeWidth="20"
            strokeLinecap="round"
          />
        </g>

        <ellipse
          className="animate-signin-wash motion-reduce:animate-none"
          cx="360"
          cy="220"
          rx="280"
          ry="190"
          fill="url(#signin-faint-glow-a)"
          opacity="0.5"
        />
        <ellipse
          className="animate-signin-wash motion-reduce:animate-none [animation-delay:-7s]"
          cx="780"
          cy="480"
          rx="260"
          ry="200"
          fill="url(#signin-faint-glow-b)"
          opacity="0.55"
        />

        <rect
          className="animate-signin-grain opacity-[0.34] mix-blend-soft-light motion-reduce:animate-none"
          width="100%"
          height="100%"
          filter="url(#signin-grain)"
        />
      </svg>
    </div>
  );
}
